<template>
    <div class="search-filter-wrap">
        <h4>{{ search_prompt }}</h4>
        <div class="search-filter" id="search-filter" :class="{'open':(autoOptions.length > 0) && optionsOpen}">
            <div class="container top">
                <input type="text" :value="search_text" @input="evt=>search_text=evt.target.value" id="searchInput" @compositionupdate="optionsOpen=true" v-on:focus="$emit('searchFocus')" :placeholder="randomEample" v-on:keyup.down="selectDown" v-on:keyup.up="selectUp" v-on:keydown.up.prevent v-on:keyup.enter="selectEnter" v-on:keypress="optionsOpen=true" aria-autocomplete="list" role="combobox" aria-controls="autoCompleteOptions" :aria-expanded="ariaExpanded" autocomplete="off" aria-label="What would you like to recycle?" :aria-activedescendant="search_temp_id" aria-haspopup="listbox">
                    <!-- ## Start SetUP 3 ## -->
                    <div class="results">
                        <ul id="autoCompleteOptions" role="listbox" v-show="(autoOptions.length > 0) && optionsOpen">
                            <li v-for="opt in autoOptions" v-bind:key="opt.item.pk" role="option" aria-selected="false" v-on:click="search_text=opt.item.name;optionsOpen=false;" v-on:mouseover="selectHover('option-'+opt.item.pk)" :id="'option-'+opt.item.pk" :data-value='opt.item.name' class="auto-option" :class="[{'auto-option_group-head': opt.item.isGroupHead, 'auto-option_item-head': !opt.item.isGroupHead}, 'in-group-'+opt.item.toGroup]">{{ opt.item.name }}</li>
                        </ul>
                        <p aria-live="polite" class="polite" v-if="autoOptions.length > 0" role="status">Search for {{search_text}} yields {{ results_count }} results.</p>
                    </div>
                    <!-- ## End SetUP 3 ## -->
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import Fuse from 'fuse.js'
export default{
    name: 'searchblock',
    data() {
        return {
            searchItems: [],
            search_text: '',
            search_text_temp: '',
            autoOptions: [],
            search_temp_id: '',
            max_auto_comp_items: 10,
            optionsOpen: false,
            fuseOptions: {
                includeScore: true,
                shouldSort: true,
                ignoreLocation: true,
                threshold: .5,
                keys: ['name']
            },
            fuseDictionary: [],
            timer: null,
        }
    },
    props: {
        pageType: {
            type: String,
            required: false,
        },
        curIndex:{
            type: Number,
            default: -1
        },
        results_count: {
            type: Number,
            default: 0
        },
        search_prompt: {
            type: String,
            default: ''
        },
        placeholders: {
            type: Array,
            default: array => new Array()
        }
    },
    watch:{
        search_temp_id() {
            let litElements = document.getElementsByClassName('lightItUp')
            litElements.forEach(x => {
                x.classList.remove('lightItUp');
                x.setAttribute('aria-selected', false);
            });
            if (this.search_temp_id != '') {
                let temp = document.getElementById(this.search_temp_id);
                temp.classList.add('lightItUp');
                temp.setAttribute('aria-selected', true);
            }
        },
        searchItems() {
            let tempDict = [];
            for (var i in this.searchItems) {
                let groupItem = this.searchItems[i];
                tempDict.push({name: groupItem.name, pk: groupItem.pk, isGroupHead: true, toGroup: groupItem.pk, groupName: groupItem.name, groupOrder: null});
                for (var x in groupItem.types) {
                    let subItem = groupItem.types[x];
                    tempDict.push({name: subItem.name, pk: subItem.pk, isGroupHead: false, toGroup: groupItem.pk, groupName: groupItem.name, groupOrder: null});
                }
            }
            this.fuseDictionary = tempDict;
        },
        search_text() {
            if (this.search_text.length > 0) {
                var searchText = this.search_text.toLowerCase().trim();
                var options = [];
                var optCount = 0;

                let fuse = new Fuse(this.fuseDictionary, this.fuseOptions);
                var results = fuse.search(searchText);

                // Get only the first this.max_auto_comp_items (should be 10) results for sorting
                results = results.slice(0, this.max_auto_comp_items)
                // Reset the group order on the items that were found. (this is needed because when groupOrder is set on the results in the loop below they change this.fuseDictionary)
                for (var z in results) {
                    results[z].item.groupOrder = null;
                }
                // Set the groupOrder, the first group should be the one that has the item with the lowest score going on from there
                // The items with the lowest score will always be first because the fuse results are presorted due to the settings
                for (var x in results) {
                    if (results[x].item.groupOrder == null) {
                        for (var y in results) {
                            if (results[x].item.toGroup == results[y].item.toGroup) {
                                results[y].item.groupOrder = x;
                            }
                        }
                    }
                }
                if (this.search_text.length > 2) {
                    // Sort the things into groups
                    results = results.sort(function(a,b) {
                            return a.item.toGroup-b.item.toGroup;
                    })
                    // Sort the groups by group order
                    results = results.sort(function(a,b) {
                        return a.item.groupOrder-b.item.groupOrder;
                    })
                }
                results = results.sort(function(a, b) {
                    return a.item.isGroupHead - b.item.isGroupHead;
                })
                this.autoOptions = results

                let isTemp = results.filter(x => {
                    return this.search_temp_id == 'option-'+x.item.pk;
                })
                if (isTemp.length <= 0){
                    this.search_temp_id = ''
                }
            } else {
                this.autoOptions = []
            }
            
            //// --- Use this to have a slight delay on searching after input has changed.
            //// Will reduce the number of querys sent as one will not be sent on every keystroke. ---
            if (this.timer) {
                clearTimeout(this.timer)
                this.timer = null
            }
            this.timer = setTimeout(() => {
                // this.emitChange(this.filter);
                this.$emit('filterChange', [{name:this.search_text}]);
            }, 250)
            
            // --- No delay between input change and searching ---
            // this.$emit('filterChange', [{name:this.search_text}])
        }
    },
    computed: {
        ariaExpanded() {
            if (this.search_text == '') {
                return 'false'
            }
            return 'true'
        },
        randomEample() {
            if (this.placeholders.length > 0) {
                return this.placeholders[Math.floor(Math.random() * this.placeholders.length)].name
            }
            return "Tin Cans"
        }
    },
    created (){
        window.addEventListener('click', this.documentClick)
        this.fetchSearchData().then(data => {
            this.searchItems = data;
        })
    },
    destroyed (){
        window.removeEventListener('click', this.documentClick)
    },
    activated() {
        window.addEventListener('click', this.documentClick)
    },
    deactivated() {
        window.removeEventListener('click', this.documentClick)
    },
    methods: {
        setSearchText(newVal) {
            this.search_text = newVal;
        },
        optionsCheck(val) {
            this.optionsOpen=true
        },
        sortOpts(a, b) {
            let comp = 0;
            comp = a.toGroup-b.toGroup || a.pk-b.pk;
            return comp;
        },
        selectHover(id) {
            this.search_temp_id = id;
        },
        selectDown() {
            if (this.search_temp_id == '') {
                var mainEle = document.getElementById('autoCompleteOptions');
                if (mainEle.hasChildNodes()) {
                    let temp = mainEle.firstElementChild;
                    this.search_temp_id = temp.id;
                }
            } else {
                var curElement = document.getElementById(this.search_temp_id);
                if (curElement.nextElementSibling) {
                    this.search_temp_id = curElement.nextElementSibling.id;
                } else {
                    this.search_temp_id = '';
                }
            }
        },
        selectUp() {
            if (this.search_temp_id == '') {
                var mainElement = document.getElementById('autoCompleteOptions');
                if (mainElement.hasChildNodes()) {
                    this.search_temp_id = mainElement.lastElementChild.id;
                }
            } else {
                var curElement = document.getElementById(this.search_temp_id);
                if (curElement.previousElementSibling) {
                    this.search_temp_id = curElement.previousElementSibling.id;
                } else {
                    this.search_temp_id = '';
                }
            }
            
        },
        selectEnter(e) {
            let curElement = document.getElementById(this.search_temp_id)
            if (curElement) {
                console.log(curElement.dataset.value)
                this.search_text = curElement.dataset.value;
            }
            this.search_temp_id = '';
            this.optionsOpen = false;
            e.target.blur();
        },
        fetchSearchData(){
            var id = this.$route.meta.id
            return axios.get('/api/get_categories').then(response => {
                //  console.log(JSON.stringify(response))
                return response.data;
            })
        },
        documentClick(e){
            let searchElement = document.getElementById('search-filter');
            if (!searchElement.contains(e.target)) {
                this.search_temp_id = '';
                this.optionsOpen = false;
            }
        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
    .polite{
        margin: 0;
        height: 0;
    }

    #searchInput {
        margin-bottom: 0;
        border: 0;
        border-bottom: thin solid transparent;
        border-radius: 0;
    }

    .open #searchInput{
        border-bottom: thin solid rgba(128, 128, 128, 0.377);
    }

    #autoCompleteOptions {
        background-color: white;
        margin-bottom: 10px;
        padding: 5px;
        background-color: white;
        color: black;
    }

    .lightItUp {
        background-color: lightblue;
    }
    .lightItUp::before {
        background: white;
    }

    .auto-option {
        margin-bottom: 0;
        /* padding-top: .5rem; */
        padding-bottom: .5rem;
        padding-left: 2rem;
        font-size: 1.35rem;
        /* border-bottom: rgba(128, 128, 128, 0.377); */
        border-bottom: thin solid rgba(128, 128, 128, 0.377);
    }
    /* .auto-option ~ .auto-option {
        padding-top: .5rem;
    } */
    /* .auto-option::before {
        padding-bottom: .5rem;
    } */

    /* .auto-option:last-of-type {
        border-bottom: none;
    } */
    #autoCompleteOptions li:last-of-type {
        border-bottom: none;
    }
    .auto-option:hover {
        cursor: pointer;
    }
    /* .auto-option_group-head { */
        /* padding-left: 0; */
        /* font-weight: bold; */
        /* border-bottom: none; */
        /* font-size: 1.35rem; */
        /* border-bottom: solid thin black; */
        /* padding-bottom: 0; */
        /* margin-bottom: .3rem; */
    /* } */

    .auto-option_item-head {
        padding-top: 0;
    }

    .auto-option_item-head ~ .auto-option_item-head {
        padding-top: .5rem;
    }

    .auto-option_group-head {
        padding-top: 0;
    }

    .auto-option_group-head ~ .auto-option_group-head {
        padding-top: .5rem;
    }

    .auto-option_item-head::before {
        content: 'Items';
        border-bottom: thin solid black;
        display: block;
        font-weight: bold;
        font-size: 1.5rem;
        margin-left: -2rem;
        margin-bottom: .5rem;
    }

    .auto-option_item-head ~ .auto-option_item-head::before {
        content: '';
        border: none;
        display: none;
        margin-left: 0;
        margin-bottom: 0;
    }

    .auto-option_group-head::before {
        content: 'Categories ';
        border-bottom: thin solid black;
        display: block;
        font-weight: bold;
        font-size: 1.5rem;
        margin-left: -2rem;
        margin-bottom: .5rem;
        padding-top: .5rem;
    }
    .auto-option_group-head ~ .auto-option_group-head::before {
        content: '';
        border: none;
        display: none;
        margin-left: 0;
        margin-bottom: 0;
        padding-top: 0;
    }
</style>